import {Injectable} from "@angular/core";
import {MatSnackBar} from "@angular/material/snack-bar";

export const defaultDuration = 4000;

@Injectable({
  providedIn: 'root'
})
export class AlertToastService {

  constructor(private snackBar: MatSnackBar) {
  }

  pushError(message: string, duration: number | false = defaultDuration) {

    const snackMessage = `Помилка: ${message}`;

    return this.open(snackMessage, null, duration);
  }

  pushWarn(message: string, duration: number | false = defaultDuration) {
    const snackMessage = `Попередження: ${message}`;
    return this.open(snackMessage, null, duration);
  }

  pushSuccess(message: string, duration: number | false = defaultDuration) {
    const snackMessage = `Готово: ${message}`;
    return this.open(snackMessage, null, duration);
  }
  private open(message: string = '', actionMessage: string = null, duration: number | false = defaultDuration) {
    const snackBarRef = this.snackBar.open(message, actionMessage, {
      panelClass: 'app-snackbar-center',
      ...(!!duration ? { duration } : {}),
    });
    return snackBarRef;
  }

}
